import type { Asset } from '@schibsted-svp/svp-api-types';

const firePixelTracker = (pixelTrackerUrl: string) => {
  const pixel = new Image();
  pixel.src = pixelTrackerUrl;
};

export const firePixelTrackers = (asset: Asset) => {
  const pixelTrackerUrl = asset.additional?.metadata?.pixelTrackerUrl;

  if (asset.provider === 'brandstudio' && pixelTrackerUrl) {
    firePixelTracker(pixelTrackerUrl);
  }
};
